import React from "react";

interface CardHeaderProps {
  title: string;
  description: string;
  actions?: React.ReactNode;
}

const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  description,
  actions,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-4 gap-2">
      <div>
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <div className="flex items-center gap-4">{actions}</div>
    </div>
  );
};

export default CardHeader;
